<template>
  <div>
    <div class="mb-2 font-bold text-sm">Kriteria penambahan stok (+):</div>
    <div>
      <ul class="stock-rule-list">
        <li>Snack yang sudah di-bundle bisa dimasukkan ke penambahan stok</li>
        <li>Pembelian snack (kulakan) <span style="color: red; font-weight: 700;">tidak</span> termasuk dalam penambahan stok karena belum di-bundle</li>
        <li>Pengembalian bundle snack sisa penjualan oleh Kondektur <span style="color: red; font-weight: 700;">tidak</span> termasuk dalam penambahan stok karena otomatis ditambahkan dari sistem</li>
      </ul>
    </div>
  </div>
</template>